import firebase from 'firebase/compat/app';
import axios from "axios";

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export function requestWithoutAuth(url, options) {
    const headers = options.headers || {};

    return axios({
        method: options.method,
        url,
        headers: {...headers},
        data: options.body,
    }).catch(error => {
        console.error('Request error:', error.response?.status, error.message);
        throw error;
    });
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
    const headers = options.headers || {};
    return firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(idToken => {
            const auth = idToken && {Authorization: `Bearer ${idToken}`};
            return axios({
                method: options.method,
                url,
                headers: {...auth, ...headers},
                data: options.body,
                timeout: 5000
            });
        }).catch(error => {
            console.error('API request error:', {
                status: error.response?.status,
                statusText: error.response?.statusText,
                url: error.config?.url,
                method: error.config?.method,
                message: error.message,
                data: error.response?.data
            });
            throw error;
        });
}

export function requestBinary(url, options) {
    const headers = options.headers || {};
    return firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(idToken => {
            const auth = idToken && {Authorization: `Bearer ${idToken}`};
            return axios({
                method: options.method,
                url,
                headers: {...auth, ...headers},
                data: options.body,
                timeout: options.timeout || 15000,
                responseType: options.responseType || 'blob'
            });
        }).catch(error => {
            console.error('Binary API request error:', {
                status: error.response?.status,
                statusText: error.response?.statusText,
                url: error.config?.url,
                method: error.config?.method,
                message: error.message,
                data: error.response?.data
            });
            throw error;
        });
}

export function uploadFile(url, file, onProgress) {
    return axios.put(url, file, {
        headers: {
            'Content-Type': file.type || 'application/octet-stream'
        },
        transformRequest: [(data) => data],
        withCredentials: false,
        onUploadProgress: onProgress ? (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percentCompleted);
        } : undefined
    }).catch(error => {
        console.error('Upload error:', {
            status: error.response?.status,
            statusText: error.response?.statusText,
            url: error.config?.url,
            headers: error.response?.headers,
            data: error.response?.data
        });
        throw error;
    });
}
